<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="factura.caja_fecha"
              label="Fecha"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="factura.turno"
              label="Turno"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="factura.usuario_iniciales"
              label="Usuario"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="factura.numero"
              label="Número"
              readonly=""
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="factura.importe"
              label="Importe"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="factura.detalle" label="Detalle"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ factura.id ? 'Actualizar' : 'Crear' }} factura
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useFacturasStore } from '@/stores/facturasStore'
import { focusFirstInput, formatDate, userIsRecepcion } from '@/utils/helpers'
import { getUser } from '@/utils/tokenStorage'
import NoPermission from '@/components/common/NoPermission.vue'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})

const facturasStore = useFacturasStore()
const userIsRecepcionValue = userIsRecepcion()
const loading = ref(false)
const emit = defineEmits(['saved'])

const factura = reactive({
  id: null,
  turno: '',
  hotel: '',
  caja_id: '',
  numero: '',
  usuario_id: '',
  importe: '',
  importe_neto: '',
  caja: '',
  cobro_id: '',
  detalle: '',
  usuario_iniciales: '',
  caja_fecha: ''
})
const isNewRecord = computed(() => !factura.id)

onMounted(async () => {
  const userInfo = getUser()
  factura.usuario = userInfo.usuario
  factura.usuario_id = userInfo.usuario_id
  factura.hotel = userInfo.hotel
  factura.turno = userInfo.turno
  const data = await facturasStore.getFactura(parseInt(props.id))
  factura.numero = data.numero
  if (props.id) {
    loading.value = true
    try {
      Object.assign(factura, data)
      factura.usuario_iniciales = data.usuario_iniciales || ''
      factura.caja_fecha = formatDate(data.caja_fecha) || ''
      factura.caja_id = data.caja_id || null
      // usuarios.value = await facturasStore.getUsuarios()
    } catch (error) {
      console.error('Error al cargar la factura:', error)
    } finally {
      loading.value = false
    }
  }
  // Add focus to first enabled input after form is loaded
  focusFirstInput()
})

// const formTitle = computed(() =>
//   props.editIndex === -1 ? 'Nueva Factura' : 'Editar Factura'
// )

const submitForm = async () => {
  loading.value = true
  try {
    if (factura.id) {
      await facturasStore.updateFactura(factura)
    } else {
      await facturasStore.createFactura({ ...factura })
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar el factura:', error)
  } finally {
    loading.value = false
  }
}
defineExpose({
  factura,
  loading,
  // usuarios,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})
</script>
